import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportsComponent } from './reports.component';
import { ReportViewerComponent } from './report-viewer/report-viewer.component';

const routes: Routes = [{
  path: '', component: ReportsComponent,
  children: [
    { path: 'report-viewer', component: ReportViewerComponent },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
  })
export class ReportsRoutingModule { }
